import { NumberValue, Schema } from '@coveo/bueno';
import { nonEmptyString } from '../../utils/validate-payload.js';
export const instantResultsOptionDefinitions = {
    searchBoxId: nonEmptyString,
    maxResultsPerQuery: new NumberValue({
        required: true,
        min: 1,
    }),
    cacheTimeout: new NumberValue(),
};
export const instantResultsOptionsSchema = new Schema(instantResultsOptionDefinitions);
